import {
  IconUser,
  IconBulb,
  IconHeart,
  IconCurrencyNaira,
} from "@tabler/icons-react";
import styles from "../../../../pages/TalentDashboard/Profile/profile.module.css";
import Reveal from "../../../Reveal/Reveal";
import { fmtCurrency } from "../../../../utils/functions";

export default function OverviewTab({ data, resetKey }) {
  const MIN = 0;
  const MAX = 10_000_000; // ₦10M

  const low = data?.desiredCompensation?.lowestAmount ?? 0;
  const high = data?.desiredCompensation?.highestAmount ?? 0;

  const left = ((low - MIN) / (MAX - MIN)) * 100;
  const right = 100 - ((high - MIN) / (MAX - MIN)) * 100;
  const fillMid = (left + (100 - right)) / 2;
  const chosenLabelPos = Math.min(80, Math.max(20, fillMid));
  return (
    <div className={styles.stack}>
      <Reveal index={0} resetKey={resetKey}>
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <div className={styles.cardHeaderLeft}>
              <div className={styles.cardIcon}>
                <IconUser size={18} />
              </div>
              <div>
                <div className={styles.cardTitle}>About Me</div>
              </div>
            </div>
          </div>
          <div className={styles.cardBody}>
            <p className={styles.bioText}>{data?.summary}</p>
          </div>
        </div>
      </Reveal>

      <div className={styles.grid2}>
        <Reveal index={1} resetKey={resetKey}>
          <div className={styles.card}>
            <div className={styles.cardHeader}>
              <div className={styles.cardHeaderLeft}>
                <div className={styles.cardIcon}>
                  <IconBulb size={18} />
                </div>
                <div>
                  <div className={styles.cardTitle}>Skills</div>
                </div>
              </div>
            </div>
            <div className={styles.cardBody}>
              <div className={styles.tagList}>
                {data?.primarySkills?.map((s) => (
                  <span className={styles.tag} key={s}>
                    {s}
                  </span>
                ))}
                {data?.secondarySkills?.map((s) => (
                  <span className={styles.tag} key={s}>
                    {s}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal index={2} resetKey={resetKey}>
          <div className={styles.card}>
            <div className={styles.cardHeader}>
              <div className={styles.cardHeaderLeft}>
                <div className={styles.cardIcon}>
                  <IconHeart size={18} />
                </div>
                <div>
                  <div className={styles.cardTitle}>Work Priorities</div>
                </div>
              </div>
            </div>
            <div className={styles.cardBody}>
              <div className={styles.tagList}>
                {data?.specificPriorities?.map((p) => (
                  <span className={styles.tag} key={p}>
                    {p}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </Reveal>
      </div>

      <Reveal index={3} resetKey={resetKey}>
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <div className={styles.cardHeaderLeft}>
              <div className={styles.cardIcon}>
                <IconCurrencyNaira size={18} />
              </div>
              <div>
                <div className={styles.cardTitle}>Salary Expectations</div>
              </div>
            </div>
          </div>
          <div className={styles.cardBody}>
            <div className={styles.salaryChosenWrap}>
              <div className={styles.salaryChosenLabel} style={{ left: `${chosenLabelPos}%` }}>
                Your salary expectations: {fmtCurrency(low, "NGN")} to {fmtCurrency(high, "NGN")}
              </div>
            </div>
            <div className={styles.salaryTrack}>
              <div
                className={styles.salaryFill}
                style={{
                  left: `${left}%`,
                  right: `${right}%`,
                }}
              />
            </div>
            <div className={styles.salaryLabels}>
              <span>{fmtCurrency(MIN, "NGN")}</span>
              <span>{fmtCurrency(MAX, "NGN")}</span>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  );
}
